import log from 'loglevel'
import { exec } from '../util/exec'
import { CiConfig, CiStage, CiPhase } from "../configuration/interface";


export const ciPhaseRunner = async (config: CiConfig, stage: CiStage, phase: CiPhase) => {
  const commands = config[stage][phase]
  log.info(`Running phase "${phase}" of stage "${stage}"`)
  // Using for loop so all awaited promises must be resolved before next cycle
  for (let i = 0; i < commands.length; i++) {
    const command = commands[i];
    await exec(command, { shell: true })
  }
} 